/*Form component in the CrewInfoEdit Form
  components to add/edit the Additional Crew
  Positions crew info */
  import React, { useRef, useState } from "react";
  import { useRedirect } from '../../../../hooks/Redirect';
  import Form from "react-bootstrap/Form";
  import Col from 'react-bootstrap/Col';
  import Row from 'react-bootstrap/Row';
  import { Alert } from "react-bootstrap";
import { Select as ManSelect } from "@mantine/core";
import { formatCrewOptionLabel } from "../crewSelectHelpers";
  import styles from "../../../../styles/Callsheets.module.css";

  
  const CrewAdditional = ({
    handleChange,
    postData,
    setShow,
    crewOptions = [],
    selectedCrewIds = {},
    handleCrewSelection,
    crewSearchQuery = "",
    setCrewSearchQuery,
    crewSearchLoading = false,
  }) => {
    useRedirect();
    // eslint-disable-next-line
    const [errors, setErrors] = useState({});
    const [isCrewSearchOpen, setIsCrewSearchOpen] = useState(false);
    const ignoreNextSearchChangeRef = useRef(false);
  
    const {add_pos_1_job, add_pos_1_name, add_pos_1_email, add_pos_1_phone,
      add_pos_2_job, add_pos_2_name, add_pos_2_email, add_pos_2_phone,
      add_pos_3_job, add_pos_3_name, add_pos_3_email, add_pos_3_phone,
      add_pos_4_job, add_pos_4_name, add_pos_4_email, add_pos_4_phone,
      add_pos_5_job, add_pos_5_name, add_pos_5_email, add_pos_5_phone,
      add_pos_6_job, add_pos_6_name, add_pos_6_email, add_pos_6_phone,
      add_pos_7_job, add_pos_7_name, add_pos_7_email, add_pos_7_phone,
      add_pos_8_job, add_pos_8_name, add_pos_8_email, add_pos_8_phone,
      add_pos_9_job, add_pos_9_name, add_pos_9_email, add_pos_9_phone,
      add_pos_10_job, add_pos_10_name, add_pos_10_email, add_pos_10_phone,
      add_pos_11_job, add_pos_11_name, add_pos_11_email, add_pos_11_phone,
      add_pos_12_job, add_pos_12_name, add_pos_12_email, add_pos_12_phone,
      add_pos_13_job, add_pos_13_name, add_pos_13_email, add_pos_13_phone,
      add_pos_14_job, add_pos_14_name, add_pos_14_email, add_pos_14_phone,
      add_pos_15_job, add_pos_15_name, add_pos_15_email, add_pos_15_phone, 
  } = postData || {};

      const renderCrewSelect = (rolePrefix, label = "Crew Member") => (
    <Row className="mt-2">
      <Col xs={12} md={{ span: 8, offset: 2 }} className="d-flex justify-content-center p-0 p-lg-2">
        <Form.Group controlId={`${rolePrefix}_crew_select`} className={`${styles.Width} `}>
          <Form.Label className={`${styles.BoldScene}`}>{label}</Form.Label>
          <ManSelect
            data={[
              { label: "(Clear selection)", value: "" },
              ...crewOptions.map((user) => ({
                label: formatCrewOptionLabel(user) || "Unnamed Crew",
                value: String(user?.id),
              })),
            ]}
            classNames={{
              input: styles.Input,
            }}
            value={selectedCrewIds?.[rolePrefix] || null}
            onChange={(value) => {
              ignoreNextSearchChangeRef.current = true;
              if (handleCrewSelection) {
                handleCrewSelection(rolePrefix)(value);
              }
            }}
            placeholder="Search by call time name"
            searchable
            onSearchChange={(nextQuery) => {
              if (ignoreNextSearchChangeRef.current) {
                ignoreNextSearchChangeRef.current = false;
                return;
              }

              const selectedId = selectedCrewIds?.[rolePrefix];
              const selectedUser = crewOptions.find(
                (user) => String(user?.id) === String(selectedId)
              );
              const selectedLabel = selectedUser
                ? formatCrewOptionLabel(selectedUser)
                : "";
              if (
                selectedLabel &&
                String(nextQuery || "").trim() === String(selectedLabel || "").trim()
              ) {
                return;
              }

              if (isCrewSearchOpen && setCrewSearchQuery) {
                setCrewSearchQuery(nextQuery);
              }
            }}
            onDropdownOpen={() => {
              setIsCrewSearchOpen(true);
              if (setCrewSearchQuery) {
                setCrewSearchQuery("");
              }
            }}
            onDropdownClose={() => {
              setIsCrewSearchOpen(false);
            }}
            filter={() => true}
            nothingFound={crewSearchLoading ? "Searching..." : "No crew found"}
          />
        </Form.Group>
      </Col>
    </Row>
  );
  // Callnames are static per position (do not derive from selected crew).
  
    return (
      <div className="pb-3 text-center">
      <div className={`mt-0 text-center ${styles.SubTitle }`}>
      <span className={`float-right pt-1 ${styles.Bold } ${styles.Close }`} onClick={() => setShow(false) } >Close</span> 
      <h5 className={`d-none d-md-block pl-5 mb-0 text-center py-1 ${styles.SubTitle }`} >
      ADDITIONAL POSITIONS</h5>
      <h5 className={`d-block d-md-none pl-5 mb-0 text-center py-1 ${styles.SubTitle }`} >
      ADDITIONAL</h5>
      </div>
      <div className={`px-2 px-md-5 mx-md-5 pt-3 ${styles.White }`}>
      {/* Additional Position 1 */}
      <div>
      <p className={`my-3 py-0 mx-md-4 ${styles.SubTitle }` } style={{ textTransform: 'uppercase'}}>
      Additional Position 1</p> 
      <div>
      <span className={`py-1 px-3 px-md-5 ${styles.BoldTitleCall }`} >
        CALLNAME: addcrew1</span> 
      </div> 
      {renderCrewSelect("add_pos_1")}
      <Row className="mt-2">
          <Col xs={12} md={{span: 8, offset: 2}} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_1_job" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Position</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_1_job"
              value={add_pos_1_job}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_1_job?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      <Row className="mt-1">
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_1_name" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Name</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_1_name"
              value={add_pos_1_name}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_1_name?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_1_phone" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Phone</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_1_phone"
              value={add_pos_1_phone}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_1_phone?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={12} md={4} className="d-flex justify-content-center mt-1 mt-md-0 p-0 p-lg-2">
          <Form.Group controlId="add_pos_1_email" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Email</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_1_email"
              value={add_pos_1_email}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_1_email?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      </div>
      {/* break */}
      <Row>
      <Col xs={12}>
      <hr className={`mt-3 mb-3`}/>
      </Col>
      </Row>
      {/* Additional Position 2 */}
      <div>
      <p className={`my-3 py-0 mx-md-4 ${styles.SubTitle }` } 
      style={{ textTransform: 'uppercase'}}>Additional Position 2</p> 
      <div>
      <span className={`py-1 px-3 px-md-5 ${styles.BoldTitleCall }`} >
        CALLNAME: addcrew2</span> 
      </div> 
      {renderCrewSelect("add_pos_2")}
      <Row className="mt-2">
          <Col xs={12} md={{span: 8, offset: 2}} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_2_job" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Position</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_2_job"
              value={add_pos_2_job}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_2_job?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      <Row className="mt-1">
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_2_name" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Name</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_2_name"
              value={add_pos_2_name}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_2_name?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_2_phone" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Phone</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_2_phone"
              value={add_pos_2_phone}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_2_phone?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={12} md={4} className="d-flex justify-content-center mt-1 mt-md-0 p-0 p-lg-2">
          <Form.Group controlId="add_pos_2_email" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Email</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_2_email"
              value={add_pos_2_email}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_2_email?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      </div>
      {/* break */}
      <Row>
      <Col xs={12}>
      <hr className={`mt-3 mb-3`}/>
      </Col>
      </Row>
      {/* Additional Position 3 */}
      <div>
      <p className={`my-3 py-0 mx-md-4 ${styles.SubTitle }` } 
      style={{ textTransform: 'uppercase'}}>Additional Position 3</p> 
      <div>
      <span className={`py-1 px-3 px-md-5 ${styles.BoldTitleCall }`} >
        CALLNAME: addcrew3</span> 
      </div> 
      {renderCrewSelect("add_pos_3")}
      <Row className="mt-2">
          <Col xs={12} md={{span: 8, offset: 2}} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_3_job" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Position</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_3_job"
              value={add_pos_3_job}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_3_job?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      <Row className="mt-1">
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_3_name" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Name</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_3_name"
              value={add_pos_3_name}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_3_name?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_3_phone" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Phone</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_3_phone"
              value={add_pos_3_phone}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_3_phone?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={12} md={4} className="d-flex justify-content-center mt-1 mt-md-0 p-0 p-lg-2">
          <Form.Group controlId="add_pos_3_email" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Email</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_3_email"
              value={add_pos_3_email}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_3_email?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      </div>
      {/* break */}
      <Row>
      <Col xs={12}>
      <hr className={`mt-3 mb-3`}/>
      </Col>
      </Row>
      {/* Additional Position 4 */}
      <div>
      <p className={`my-3 py-0 mx-md-4 ${styles.SubTitle }` } 
      style={{ textTransform: 'uppercase'}}>Additional Position 4</p> 
      <div>
      <span className={`py-1 px-3 px-md-5 ${styles.BoldTitleCall }`} >
        CALLNAME: addcrew4</span> 
      </div> 
      {renderCrewSelect("add_pos_4")}
      <Row className="mt-2">
          <Col xs={12} md={{span: 8, offset: 2}} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_4_job" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Position</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_4_job"
              value={add_pos_4_job}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_4_job?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      <Row className="mt-1">
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_4_name" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Name</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_4_name"
              value={add_pos_4_name}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_4_name?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_4_phone" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Phone</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_4_phone"
              value={add_pos_4_phone}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_4_phone?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={12} md={4} className="d-flex justify-content-center mt-1 mt-md-0 p-0 p-lg-2">
          <Form.Group controlId="add_pos_4_email" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Email</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_4_email"
              value={add_pos_4_email}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_4_email?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      </div>
      {/* break */}
      <Row>
      <Col xs={12}>
      <hr className={`mt-3 mb-3`}/>
      </Col>
      </Row>
      {/* Additional Position 5 */}
      <div>
      <p className={`my-3 py-0 mx-md-4 ${styles.SubTitle }` } 
      style={{ textTransform: 'uppercase'}}>Additional Position 5</p> 
      <div>
      <span className={`py-1 px-3 px-md-5 ${styles.BoldTitleCall }`} >
        CALLNAME: addcrew5</span> 
      </div> 
      {renderCrewSelect("add_pos_5")}
      <Row className="mt-2">
          <Col xs={12} md={{span: 8, offset: 2}} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_5_job" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Position</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_5_job"
              value={add_pos_5_job}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_5_job?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      <Row className="mt-1">
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_5_name" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Name</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_5_name"
              value={add_pos_5_name}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_5_name?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_5_phone" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Phone</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_5_phone"
              value={add_pos_5_phone}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_5_phone?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={12} md={4} className="d-flex justify-content-center mt-1 mt-md-0 p-0 p-lg-2">
          <Form.Group controlId="add_pos_5_email" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Email</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_5_email"
              value={add_pos_5_email}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_5_email?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      </div>
      {/* break */}
      <Row>
      <Col xs={12}>
      <hr className={`mt-3 mb-3`}/>
      </Col>
      </Row>
      {/* Additional Position 6 */}
      <div>
      <p className={`my-3 py-0 mx-md-4 ${styles.SubTitle }` } 
      style={{ textTransform: 'uppercase'}}>Additional Position 6</p> 
      <div>
      <span className={`py-1 px-3 px-md-5 ${styles.BoldTitleCall }`} >
        CALLNAME: addcrew6</span> 
      </div> 
      {renderCrewSelect("add_pos_6")}
      <Row className="mt-2">
          <Col xs={12} md={{span: 8, offset: 2}} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_6_job" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Position</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_6_job"
              value={add_pos_6_job}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_6_job?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      <Row className="mt-1">
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_6_name" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Name</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_6_name"
              value={add_pos_6_name}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_6_name?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_6_phone" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Phone</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_6_phone"
              value={add_pos_6_phone}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_6_phone?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={12} md={4} className="d-flex justify-content-center mt-1 mt-md-0 p-0 p-lg-2">
          <Form.Group controlId="add_pos_6_email" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Email</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_6_email"
              value={add_pos_6_email}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_6_email?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      </div>
      {/* break */}
      <Row>
      <Col xs={12}>
      <hr className={`mt-3 mb-3`}/>
      </Col>
      </Row>
      {/* Additional Position 7 */}
      <div>
      <p className={`my-3 py-0 mx-md-4 ${styles.SubTitle }` } 
      style={{ textTransform: 'uppercase'}}>Additional Position 7</p> 
      <div>
      <span className={`py-1 px-3 px-md-5 ${styles.BoldTitleCall }`} >
        CALLNAME: addcrew7</span> 
      </div> 
      {renderCrewSelect("add_pos_7")}
      <Row className="mt-2">
          <Col xs={12} md={{span: 8, offset: 2}} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_7_job" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Position</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_7_job"
              value={add_pos_7_job}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_7_job?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      <Row className="mt-1">
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_7_name" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Name</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_7_name"
              value={add_pos_7_name}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_7_name?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_7_phone" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Phone</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_7_phone"
              value={add_pos_7_phone}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_7_phone?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={12} md={4} className="d-flex justify-content-center mt-1 mt-md-0 p-0 p-lg-2">
          <Form.Group controlId="add_pos_7_email" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Email</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_7_email"
              value={add_pos_7_email}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_7_email?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      </div>
      {/* break */}
      <Row>
      <Col xs={12}>
      <hr className={`mt-3 mb-3`}/>
      </Col>
      </Row>
      {/* Additional Position 8 */}
      <div>
      <p className={`my-3 py-0 mx-md-4 ${styles.SubTitle }` } 
      style={{ textTransform: 'uppercase'}}>Additional Position 8</p> 
      <div>
      <span className={`py-1 px-3 px-md-5 ${styles.BoldTitleCall }`} >
        CALLNAME: addcrew8</span> 
      </div> 
      {renderCrewSelect("add_pos_8")}
      <Row className="mt-2">
          <Col xs={12} md={{span: 8, offset: 2}} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_8_job" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Position</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_8_job"
              value={add_pos_8_job}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_8_job?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      <Row className="mt-1">
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_8_name" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Name</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_8_name"
              value={add_pos_8_name}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_8_name?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_8_phone" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Phone</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_8_phone"
              value={add_pos_8_phone}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_8_phone?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={12} md={4} className="d-flex justify-content-center mt-1 mt-md-0 p-0 p-lg-2">
          <Form.Group controlId="add_pos_8_email" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Email</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_8_email"
              value={add_pos_8_email}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_8_email?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      </div>
      {/* break */}
      <Row>
      <Col xs={12}>
      <hr className={`mt-3 mb-3`}/>
      </Col>
      </Row>
      {/* Additional Position 9 */}
      <div>
      <p className={`my-3 py-0 mx-md-4 ${styles.SubTitle }` } 
      style={{ textTransform: 'uppercase'}}>Additional Position 9</p> 
      <div>
      <span className={`py-1 px-3 px-md-5 ${styles.BoldTitleCall }`} >
        CALLNAME: addcrew9</span> 
      </div> 
      {renderCrewSelect("add_pos_9")}
      <Row className="mt-2">
          <Col xs={12} md={{span: 8, offset: 2}} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_9_job" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Position</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_9_job"
              value={add_pos_9_job}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_9_job?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      <Row className="mt-1">
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_9_name" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Name</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_9_name"
              value={add_pos_9_name}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_9_name?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_9_phone" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Phone</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_9_phone"
              value={add_pos_9_phone}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_9_phone?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={12} md={4} className="d-flex justify-content-center mt-1 mt-md-0 p-0 p-lg-2">
          <Form.Group controlId="add_pos_9_email" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Email</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_9_email"
              value={add_pos_9_email}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_9_email?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      </div>
      {/* break */}
      <Row>
      <Col xs={12}>
      <hr className={`mt-3 mb-3`}/>
      </Col>
      </Row>
      {/* Additional Position 10 */}
      <div>
      <p className={`my-3 py-0 mx-md-4 ${styles.SubTitle }` } 
      style={{ textTransform: 'uppercase'}}>Additional Position 10</p> 
      <div>
      <span className={`py-1 px-3 px-md-5 ${styles.BoldTitleCall }`} >
        CALLNAME: addcrew10</span> 
      </div> 
      {renderCrewSelect("add_pos_10")}
      <Row className="mt-2">
          <Col xs={12} md={{span: 8, offset: 2}} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_10_job" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Position</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_10_job"
              value={add_pos_10_job}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_10_job?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      <Row className="mt-1">
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_10_name" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Name</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_10_name"
              value={add_pos_10_name}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_10_name?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_10_phone" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Phone</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_10_phone"
              value={add_pos_10_phone}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_10_phone?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={12} md={4} className="d-flex justify-content-center mt-1 mt-md-0 p-0 p-lg-2">
          <Form.Group controlId="add_pos_10_email" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Email</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_10_email"
              value={add_pos_10_email}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_10_email?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      </div>
      {/* break */}
      <Row>
      <Col xs={12}>
      <hr className={`mt-3 mb-3`}/>
      </Col>
      </Row>
      {/*  Additional Position 11 */} 
      <div>
        <p className={`mb-3 py-0 mx-md-4 ${styles.SubTitle }` } 
        style={{ textTransform: 'uppercase'}}>Additional Position 11</p> 
        <div>
        <span className={`py-1 px-3 px-md-5 ${styles.BoldTitleCall }`} >
            CALLNAME: addcrew11</span> 
        </div>
        {renderCrewSelect("add_pos_11")}
        {/* Position */}
        <Row className="mt-2">
          <Col xs={12} md={{span: 8, offset: 2}} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_11_job" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Position</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_11_job"
              value={add_pos_11_job}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_11_job?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
        </Row>
        <Row className="mt-2">
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_11_name" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Name</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_11_name"
              value={add_pos_11_name}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_11_name?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_11_phone" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Phone</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_11_phone"
              value={add_pos_11_phone}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_11_phone?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={12} md={4} className="d-flex justify-content-center mt-1 mt-md-0 p-0 p-lg-2">
          <Form.Group controlId="add_pos_11_email" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Email</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_11_email"
              value={add_pos_11_email}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_11_email?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      </div>
      {/* break */}
      <Row>
      <Col xs={12}>
      <hr className={`mt-3 mb-3`}/>
      </Col>
      </Row>
      {/* Additional Position 12 */} 
      <div>
          <p className={`my-3 py-0 mx-md-4 ${styles.SubTitle }` } 
          style={{ textTransform: 'uppercase'}}>Additional Position 12</p> 
          <div>
          <span className={`py-1 px-3 px-md-5 ${styles.BoldTitleCall }`} >
              CALLNAME: addcrew12</span> 
          </div>
          {renderCrewSelect("add_pos_12")}
          {/* Position */}
          <Row className="mt-2">
            <Col xs={12} md={{span: 8, offset: 2}} className="d-flex justify-content-center p-0 p-lg-2">
            <Form.Group controlId="add_pos_12_job" className={`${styles.Width} `}  >
                <Form.Label className={`${styles.BoldScene} `} >Position</Form.Label>
                <Form.Control 
                className={`${styles.Input}`}
                type="text"
                name="add_pos_12_job"
                value={add_pos_12_job}
                onChange={handleChange}
                    />
            </Form.Group>
            {errors?.add_pos_12_job?.map((message, idx) => (
              <Alert variant="warning" key={idx}>
                {message}
              </Alert>
            ))}
            </Col>
          </Row>
          <Row className="mt-2">
            <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
            <Form.Group controlId="add_pos_12_name" className={`${styles.Width2} `}  >
                <Form.Label className={`${styles.BoldScene} `} >Name</Form.Label>
                <Form.Control 
                className={`${styles.Input}`}
                type="text"
                name="add_pos_12_name"
                value={add_pos_12_name}
                onChange={handleChange}
                    />
            </Form.Group>
            {errors?.add_pos_12_name?.map((message, idx) => (
              <Alert variant="warning" key={idx}>
                {message}
              </Alert>
            ))}
            </Col>
            <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
            <Form.Group controlId="add_pos_12_phone" className={`${styles.Width2} `}  >
                <Form.Label className={`${styles.BoldScene}`} >Phone</Form.Label>
                <Form.Control 
                className={`${styles.Input}`}
                type="text"
                name="add_pos_12_phone"
                value={add_pos_12_phone}
                onChange={handleChange}
                    />
            </Form.Group>
            {errors?.add_pos_12_phone?.map((message, idx) => (
              <Alert variant="warning" key={idx}>
                {message}
              </Alert>
            ))}
            </Col>
            <Col xs={12} md={4} className="d-flex justify-content-center mt-1 mt-md-0 p-0 p-lg-2">
            <Form.Group controlId="add_pos_12_email" className={`${styles.Width2} `}  >
                <Form.Label className={`${styles.BoldScene}`} >Email</Form.Label>
                <Form.Control 
                className={`${styles.Input}`}
                type="text"
                name="add_pos_12_email"
                value={add_pos_12_email}
                onChange={handleChange}
                    />
            </Form.Group>
            {errors?.add_pos_12_email?.map((message, idx) => (
              <Alert variant="warning" key={idx}>
                {message}
              </Alert>
            ))}
            </Col>
        </Row>
      </div>
      {/* break */}
      <Row>
        <Col xs={12}>
        <hr className={`mt-3 mb-3`}/>
        </Col>
        </Row>
      {/* Additional Position 13 */} 
      <div>
          <p className={`my-3 py-0 mx-md-4 ${styles.SubTitle }` } 
          style={{ textTransform: 'uppercase'}}>Additional Position 13</p> 
          <div>
          <span className={`py-1 px-3 px-md-5 ${styles.BoldTitleCall }`} >
              CALLNAME: addcrew13</span> 
          </div>
          {renderCrewSelect("add_pos_13")}
          {/* Position */}
          <Row className="mt-2">
            <Col xs={12} md={{span: 8, offset: 2}} className="d-flex justify-content-center p-0 p-lg-2">
            <Form.Group controlId="add_pos_13_job" className={`${styles.Width} `}  >
                <Form.Label className={`${styles.BoldScene} `} >Position</Form.Label>
                <Form.Control 
                className={`${styles.Input}`}
                type="text"
                name="add_pos_13_job"
                value={add_pos_13_job}
                onChange={handleChange}
                    />
            </Form.Group>
            {errors?.add_pos_13_job?.map((message, idx) => (
              <Alert variant="warning" key={idx}>
                {message}
              </Alert>
            ))}
            </Col>
          </Row>
          <Row className="mt-2">
            <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
            <Form.Group controlId="add_pos_13_name" className={`${styles.Width2} `}  >
                <Form.Label className={`${styles.BoldScene} `} >Name</Form.Label>
                <Form.Control 
                className={`${styles.Input}`}
                type="text"
                name="add_pos_13_name"
                value={add_pos_13_name}
                onChange={handleChange}
                    />
            </Form.Group>
            {errors?.add_pos_13_name?.map((message, idx) => (
              <Alert variant="warning" key={idx}>
                {message}
              </Alert>
            ))}
            </Col>
            <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
            <Form.Group controlId="add_pos_13_phone" className={`${styles.Width2} `}  >
                <Form.Label className={`${styles.BoldScene}`} >Phone</Form.Label>
                <Form.Control 
                className={`${styles.Input}`}
                type="text"
                name="add_pos_13_phone"
                value={add_pos_13_phone}
                onChange={handleChange}
                    />
            </Form.Group>
            {errors?.add_pos_13_phone?.map((message, idx) => (
              <Alert variant="warning" key={idx}>
                {message}
              </Alert>
            ))}
            </Col>
            <Col xs={12} md={4} className="d-flex justify-content-center mt-1 mt-md-0 p-0 p-lg-2">
            <Form.Group controlId="add_pos_13_email" className={`${styles.Width2} `}  >
                <Form.Label className={`${styles.BoldScene}`} >Email</Form.Label>
                <Form.Control 
                className={`${styles.Input}`}
                type="text"
                name="add_pos_13_email"
                value={add_pos_13_email}
                onChange={handleChange}
                    />
            </Form.Group>
            {errors?.add_pos_13_email?.map((message, idx) => (
              <Alert variant="warning" key={idx}>
                {message}
              </Alert>
            ))}
            </Col>
        </Row>
      </div>
      {/* break */}
      <Row>
        <Col xs={12}>
        <hr className={`mt-3 mb-3`}/>
        </Col>
        </Row>
      {/* Additional Position 14 */} 
      <div>
          <p className={`my-3 py-0 mx-md-4 ${styles.SubTitle }` } 
          style={{ textTransform: 'uppercase'}}>Additional Position 14</p> 
          <div>
          <span className={`py-1 px-3 px-md-5 ${styles.BoldTitleCall }`} >
              CALLNAME: addcrew14</span> 
          </div>
          {renderCrewSelect("add_pos_14")}
          {/* Position */}
          <Row className="mt-2">
            <Col xs={12} md={{span: 8, offset: 2}} className="d-flex justify-content-center p-0 p-lg-2">
            <Form.Group controlId="add_pos_14_job" className={`${styles.Width} `}  >
                <Form.Label className={`${styles.BoldScene} `} >Position</Form.Label>
                <Form.Control 
                className={`${styles.Input}`}
                type="text"
                name="add_pos_14_job"
                value={add_pos_14_job}
                onChange={handleChange}
                    />
            </Form.Group>
            {errors?.add_pos_14_job?.map((message, idx) => (
              <Alert variant="warning" key={idx}>
                {message}
              </Alert>
            ))}
            </Col>
          </Row>
          <Row className="mt-2">
            <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
            <Form.Group controlId="add_pos_14_name" className={`${styles.Width2} `}  >
                <Form.Label className={`${styles.BoldScene} `} >Name</Form.Label>
                <Form.Control 
                className={`${styles.Input}`}
                type="text"
                name="add_pos_14_name"
                value={add_pos_14_name}
                onChange={handleChange}
                    />
            </Form.Group>
            {errors?.add_pos_14_name?.map((message, idx) => (
              <Alert variant="warning" key={idx}>
                {message}
              </Alert>
            ))}
            </Col>
            <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
            <Form.Group controlId="add_pos_14_phone" className={`${styles.Width2} `}  >
                <Form.Label className={`${styles.BoldScene}`} >Phone</Form.Label>
                <Form.Control 
                className={`${styles.Input}`}
                type="text"
                name="add_pos_14_phone"
                value={add_pos_14_phone}
                onChange={handleChange}
                    />
            </Form.Group>
            {errors?.add_pos_14_phone?.map((message, idx) => (
              <Alert variant="warning" key={idx}>
                {message}
              </Alert>
            ))}
            </Col>
            <Col xs={12} md={4} className="d-flex justify-content-center mt-1 mt-md-0 p-0 p-lg-2">
            <Form.Group controlId="add_pos_14_email" className={`${styles.Width2} `}  >
                <Form.Label className={`${styles.BoldScene}`} >Email</Form.Label>
                <Form.Control 
                className={`${styles.Input}`}
                type="text"
                name="add_pos_14_email"
                value={add_pos_14_email}
                onChange={handleChange}
                    />
            </Form.Group>
            {errors?.add_pos_14_email?.map((message, idx) => (
              <Alert variant="warning" key={idx}>
                {message}
              </Alert>
            ))}
            </Col>
        </Row>
      </div>
      {/* break */}
      <Row>
      <Col xs={12}>
      <hr className={`mt-3 mb-3`}/>
      </Col>
      </Row>
      {/* Additional Position 15 */} 
      <div>
        <p className={`my-3 py-0 mx-md-4 ${styles.SubTitle }` } 
        style={{ textTransform: 'uppercase'}}>Additional Position 15 </p> 
        <div>
        <span className={`py-1 px-3 px-md-5 ${styles.BoldTitleCall }`} >
            CALLNAME: addcrew15</span>
        </div>
        {renderCrewSelect("add_pos_15")}
        {/* Position */}
        <Row className="mt-2">
          <Col xs={12} md={{span: 8, offset: 2}} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_15_job" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Position</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_15_job"
              value={add_pos_15_job}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_15_job?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
        </Row>
        <Row className="mt-2">
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_15_name" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Name</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_15_name"
              value={add_pos_15_name}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_15_name?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="add_pos_15_phone" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Phone</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_15_phone"
              value={add_pos_15_phone}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_15_phone?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={12} md={4} className="d-flex justify-content-center mt-1 mt-md-0 p-0 p-lg-2">
          <Form.Group controlId="add_pos_15_email" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Email</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="add_pos_15_email"
              value={add_pos_15_email}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.add_pos_15_email?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
    </div>
      {/* break */}
      <Row>
      <Col xs={12}>
      <hr className={`mt-3 mb-3`}/>
      </Col>
      </Row>
      </div>
      </div>
    )
  }
  
  export default CrewAdditional

